import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const SobrePage = () => {
  useEffect(() => {
    // Update document title
    document.title = 'Sobre Nós - Carbone Soluções Financeiras Campinas';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Saiba mais sobre a Carbone Soluções Financeiras em Campinas. Conheça nossa equipe de especialistas, nosso compromisso com atendimento de qualidade e as melhores soluções em crédito consignado. Transparência e confiança são nossos pilares.');
    }

    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://example.com/sobre');
    }

    // Add JSON-LD structured data
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Sobre Nós - Carbone Soluções Financeiras",
      "description": "Saiba mais sobre a Carbone Soluções Financeiras, nossa equipe e nosso compromisso em oferecer as melhores soluções em crédito consignado.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/sobre`
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Atendimento Humano',
      description: 'Tratamos cada cliente com respeito, empatia e atenção personalizada',
    },
    {
      icon: 'ri-speed-line',
      title: 'Agilidade',
      description: 'Processos rápidos e eficientes para você ter seu crédito quando precisar',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Transparência',
      description: 'Sem letras miúdas, taxas ocultas ou surpresas desagradáveis',
    },
    {
      icon: 'ri-star-line',
      title: 'Excelência',
      description: 'Buscamos sempre superar as expectativas dos nossos clientes',
    },
  ];

  const team = [
    {
      name: 'Ricardo Carbone',
      role: 'Diretor Geral',
      image: 'https://public.readdy.ai/ai/img_res/b764310a4c2ab38dc41f6d0c59dd5a06.jpg',
    },
    {
      name: 'Juliana Santos',
      role: 'Gerente Comercial',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20in%20elegant%20navy%20blazer%20smiling%20warmly%20in%20modern%20office%20with%20simple%20clean%20white%20background%20natural%20lighting%20confident%20friendly%20expression%20realistic%20photography%20high%20quality&width=400&height=500&seq=team2-navy&orientation=portrait',
    },
    {
      name: 'Fernando Oliveira',
      role: 'Coordenador de Atendimento',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20man%20in%20business%20casual%20navy%20attire%20smiling%20friendly%20in%20modern%20office%20with%20simple%20clean%20white%20background%20natural%20lighting%20approachable%20expression%20realistic%20photography%20high%20quality&width=400&height=500&seq=team3-navy&orientation=portrait',
    },
    {
      name: 'Mariana Costa',
      role: 'Especialista em Crédito',
      image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20business%20woman%20in%20professional%20navy%20attire%20smiling%20confidently%20in%20modern%20office%20with%20simple%20clean%20white%20background%20natural%20lighting%20expert%20expression%20realistic%20photography%20high%20quality&width=400&height=500&seq=team4-navy&orientation=portrait',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-32 pb-16 bg-gradient-to-br from-navy-50 via-white to-gold-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-5xl lg:text-6xl font-bold text-navy-900 mb-6">
              Sobre a Carbone
            </h1>
            <p className="text-xl text-navy-600 max-w-3xl mx-auto leading-relaxed">
              Especialistas em crédito consignado com atendimento humano, rápido e transparente
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-navy-200 to-gold-200 rounded-3xl blur-2xl opacity-30"></div>
              <div className="relative w-full h-[600px] flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20diverse%20brazilian%20financial%20services%20team%20working%20together%20in%20modern%20bright%20office%20with%20navy%20blue%20and%20gold%20accents%20elegant%20corporate%20atmosphere%20helping%20clients%20realistic%20photography%20high%20quality&width=700&height=900&seq=about-hero-navy&orientation=portrait"
                  alt="Equipe Carbone"
                  className="w-full h-full object-cover rounded-3xl shadow-2xl"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-navy-900 text-white px-8 py-4 rounded-2xl shadow-xl">
                <p className="text-sm font-semibold text-gold-400">Desde 2010</p>
                <p className="text-3xl font-bold">15 anos</p>
              </div>
            </div>

            <div>
              <span className="text-gold-500 font-semibold text-sm uppercase tracking-wide">
                Quem Somos
              </span>
              <h2 className="text-4xl lg:text-5xl font-bold text-navy-900 mt-3 mb-6">
                Especialistas em
                <br />
                <span className="text-gold-500">Crédito Consignado</span>
              </h2>
              <p className="text-navy-600 text-lg leading-relaxed mb-6">
                A Carbone Soluções Financeiras nasceu em 2010 com um propósito claro: oferecer crédito consignado com dignidade, respeito e transparência. Ao longo de mais de 15 anos, nos tornamos referência no mercado por nosso atendimento humanizado e compromisso com a satisfação dos nossos clientes.
              </p>
              <p className="text-navy-600 text-lg leading-relaxed mb-8">
                Somos uma correspondente bancária devidamente autorizada pelo Banco Central do Brasil, operando com total conformidade às normas do sistema financeiro nacional. Nossa equipe é formada por profissionais experientes e dedicados a encontrar as melhores soluções para cada necessidade.
              </p>

              <div className="grid grid-cols-2 gap-8">
                <div>
                  <div className="text-5xl font-bold text-gold-500 mb-2">50mil+</div>
                  <div className="text-navy-600 font-medium">Clientes Atendidos</div>
                </div>
                <div>
                  <div className="text-5xl font-bold text-gold-500 mb-2">98%</div>
                  <div className="text-navy-600 font-medium">Satisfação</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-gradient-to-br from-navy-50 via-white to-gold-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-navy-900 mb-4">
              Nossos Valores
            </h2>
            <p className="text-xl text-navy-600 max-w-2xl mx-auto">
              Princípios que guiam nosso trabalho todos os dias
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-navy-100"
              >
                <div className="w-16 h-16 bg-navy-900 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${value.icon} text-4xl text-gold-400`}></i>
                </div>
                <h3 className="text-xl font-bold text-navy-900 mb-3">{value.title}</h3>
                <p className="text-navy-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-navy-900 mb-4">
              Nossa Equipe
            </h2>
            <p className="text-xl text-navy-600 max-w-2xl mx-auto">
              Profissionais dedicados a oferecer o melhor atendimento
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-navy-100"
              >
                <div className="relative w-full h-80 flex items-center justify-center overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-navy-900 mb-1">{member.name}</h3>
                  <p className="text-gold-500 font-medium">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-navy-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Faça parte da nossa história
          </h2>
          <p className="text-xl text-white/80 mb-8 leading-relaxed">
            Junte-se a mais de 50 mil clientes que já confiaram na Carbone para realizar seus sonhos e objetivos financeiros
          </p>
          <a
            href="https://wa.me/5519971344445?text=Olá! Quero conhecer melhor a Carbone e suas soluções."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold text-lg px-10 py-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Fale Conosco
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SobrePage;
